import * as React from "react"
import { Link } from "@inertiajs/react"
import { Menu, X } from "lucide-react"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { track } from "@/lib/analytics"
import { Wordmark } from "./Wordmark"

// In-page section anchors live on the homepage; prefixing with "/" means they
// scroll when already home and navigate-then-scroll from any other page.
const SECTION_LINKS = [
  { label: "The Partnership", href: "/#offer" },
  { label: "Approach", href: "/#growth-loop" },
  { label: "Blog", href: "/blog" },
]

export function MarketingNav() {
  const [mobileOpen, setMobileOpen] = React.useState(false)

  return (
    <header className="sticky top-0 z-40 border-b border-hairline bg-page/85 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 sm:px-6">
        <Link href="/" className="no-underline" aria-label="FullCast home">
          <Wordmark />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-8 md:flex">
          {SECTION_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-ink-body no-underline transition-colors hover:text-ink-display"
            >
              {link.label}
            </a>
          ))}
          <Link
            href="/about"
            className="text-sm font-medium text-ink-body no-underline transition-colors hover:text-ink-display"
          >
            About
          </Link>
          <Button asChild size="sm">
            <Link href="/apply" onClick={() => track("CTA Click")}>
              Apply for a Fit Call
            </Link>
          </Button>
        </nav>

        {/* Mobile toggle */}
        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-hairline text-ink-body hover:bg-surface md:hidden"
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileOpen}
        >
          {mobileOpen ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={cn(
          "border-t border-hairline bg-page md:hidden",
          mobileOpen ? "block" : "hidden",
        )}
      >
        <nav className="mx-auto flex max-w-6xl flex-col gap-1 px-4 py-3 sm:px-6">
          {SECTION_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="rounded-md px-2 py-2 text-sm font-medium text-ink-body no-underline hover:bg-surface"
            >
              {link.label}
            </a>
          ))}
          <Link
            href="/about"
            onClick={() => setMobileOpen(false)}
            className="rounded-md px-2 py-2 text-sm font-medium text-ink-body no-underline hover:bg-surface"
          >
            About
          </Link>
          <Button asChild className="mt-2 w-full">
            <Link
              href="/apply"
              onClick={() => {
                track("CTA Click")
                setMobileOpen(false)
              }}
            >
              Apply for a Fit Call
            </Link>
          </Button>
        </nav>
      </div>
    </header>
  )
}
